import { getErrorObjectsList } from '@shared/utils/helpers';
import { ErrorMessageStrategy, ResponseError } from '@shared/utils/interfaces';

export const operatorProductStatusChangingExceptionStrategy: ErrorMessageStrategy = (error: ResponseError) => {
  return {
    translationKey: 'errors.OPERATOR_PRODUCT_STATUS_CHANGING_EXCEPTION',
    translationParams: {
      products: getErrorObjectsList(error),
    },
  };
};
